import React, { useEffect, useRef, useState } from "react";
import { Button, Input, Row, Col, Form, InputGroup } from "reactstrap";
import { CiSquareRemove } from "react-icons/ci";
import { IoMdSend } from "react-icons/io";
import { getApi, postApi } from "../../AppApis";
import { BsThreeDotsVertical } from "react-icons/bs";
import { IoDocumentTextOutline } from "react-icons/io5";
import { RiAttachment2 } from "react-icons/ri";
import { BsEmojiSmile } from "react-icons/bs";
import EmojiPicker from "emoji-picker-react";

function ChatInput(props) {
    const [textMessage, settextMessage] = useState("");
    const [isOpen, setisOpen] = useState(false);
    const [file, setfile] = useState(null);
    const [mediaFileName, setMedialFileName] = useState(null);
    const [user_docs, setUser_docs] = useState([]);
    const [moreIconClicked, setMoreIconClicked] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [selectedDocumentName, setSelectedDocumentName] = useState(null);
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [isImageUploading, setIsImageUploading] = useState(false);
    const [previewDocument, setPreviewDocument] = useState(null);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [isTyping, setIsTyping] = useState(false);

    const attachmentIconRef = useRef();
    const emojiPickerRef = useRef();
    const typingTimeoutRef = useRef();
    const [media_msg, setMedia_msg] = useState({
        message: null,
        media_file: null,
    });
    const inputRef = useRef();
    const handleClickOutside = (event) => {
        if (attachmentIconRef.current && !attachmentIconRef.current.contains(event.target)) {
            setMoreIconClicked(false);
        }
        if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
            setShowEmojiPicker(false);
        }
    };
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            // Cleanup typing timeout on unmount
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }
        };
    }, []);

    const convertImageToBase64 = async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        const uploadedUrl = await postApi("/messaging/upload-image", formData, true);
        return uploadedUrl.response.url;
    };

    const sendTypingStatus = (isTyping) => {
        if (props.ws && props.ws.readyState === WebSocket.OPEN && props.conversationId) {
            props.ws.send(
                JSON.stringify({
                    type: "typing_status",
                    conversation_id: props.conversationId,
                    is_typing: isTyping,
                })
            );
        }
    };

    const handleTyping = () => {
        if (!isTyping) {
            setIsTyping(true);
            sendTypingStatus(true);
        }

        // Clear existing timeout
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }

        // Set new timeout to stop typing after 2 seconds of inactivity
        typingTimeoutRef.current = setTimeout(() => {
            setIsTyping(false);
            sendTypingStatus(false);
        }, 2000);
    };

    const handleChange = async (e) => {
        if (e.target.type === "file") {
            const selectedFile = e.target.files[0];

            // Show immediate placeholder with loading state
            setfile(selectedFile);
            setMedialFileName(selectedFile?.name);
            setIsImageUploading(true);
            setMoreIconClicked(false);

            try {
                const base64String = await convertImageToBase64(selectedFile);
                console.log("base64String", base64String);

                setMedia_msg((prevMediaMsg) => ({
                    ...prevMediaMsg,
                    media_file: selectedFile,
                    base64String,
                }));
                props.setMedia_image({ base64String, fileName: selectedFile?.name });
            } catch (error) {
                console.error("Error uploading image:", error);
                // Reset on error
                setfile(null);
                setMedialFileName(null);
            } finally {
                setIsImageUploading(false);
            }

            e.target.value = null;
        } else {
            settextMessage(e.target.value);
            setMedia_msg((prevMediaMsg) => ({
                ...prevMediaMsg,
                message: e.target.value,
            }));

            // Handle typing indicator
            if (e.target.value && e.target.value.trim() !== "") {
                handleTyping();
            } else {
                // Stop typing when input is empty
                if (isTyping) {
                    setIsTyping(false);
                    sendTypingStatus(false);
                    if (typingTimeoutRef.current) {
                        clearTimeout(typingTimeoutRef.current);
                    }
                }
            }
        }
    };

    const onaddMessage = (e, textMessage) => {
        if (e) {
            e.preventDefault();
        }

        // Stop typing indicator when sending message
        if (isTyping) {
            setIsTyping(false);
            sendTypingStatus(false);
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }
        }

        if (textMessage !== "") {
            props.onaddMessage(textMessage, "textMessage");
            settextMessage("");
        }
        if (selectedDocument) {
            props.onaddMessage(selectedDocument, "media_msg");
            setSelectedDocument(null);
            return;
        }
        if (file !== null) {
            props.onaddMessage(file, "fileMessage");
            setfile(null);
            setMedialFileName(null);
            settextMessage("");
        }
        if (media_msg.media_file && media_msg.message !== null) {
            props.onaddMessage(media_msg, "media_msg");
            setMedia_msg({ media_file: null, message: null });
            setfile(null);
            setMedialFileName(null);
            settextMessage("");
            return;
        }
    };

    const onEmojiClick = (emojiObject) => {
        const emoji = emojiObject.emoji;
        settextMessage((prevMessage) => {
            const newMessage = prevMessage + emoji;
            setMedia_msg((prevMediaMsg) => ({
                ...prevMediaMsg,
                message: newMessage,
            }));
            return newMessage;
        });
        setShowEmojiPicker(false);
    };

    const handleRemoveMediaFile = () => {
        setMedia_msg({ media_file: null, message: null });
        setSelectedDocument(null);
        setSelectedDocumentName(null);
        setIsDocumentLoading(false);
        setIsImageUploading(false);
        setMedialFileName(null);
        setfile(null);
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
            fileInput.value = null;
        }
    };

    useEffect(() => {
        fetchUserDocuemts();
        setMedialFileName(null);
        setfile(null);
        settextMessage("");
        setMedia_msg({ media_file: null, message: null });
        setIsImageUploading(false);
        setIsDocumentLoading(false);
    }, [props.sellerDetails]);

    const fetchUserDocuemts = async () => {
        try {
            const res = await getApi("/documents/user-documents");
            if (res.response) {
                setUser_docs(res.response.data.data);
            }
        } catch (error) {
            console.log("Error::", error);
        }
    };
    const handleSelect = async (item) => {
        if (!item.url) return;

        setIsDocumentLoading(true);
        setSelectedDocumentName(item.name);
        setisOpen(false);

        const authUser = localStorage.getItem("authUser");
        const token = authUser.replace(/^"|"$/g, "");

        try {
            const response = await fetch(`https://admin.onmls.com/api` + item.url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch file");
            }

            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);

            setPreviewDocument(objectUrl);
            setSelectedDocument(item.url);
            props.setMedia_image({ base64String: item.url, fileName: item.name, fileType: "document" });
        } catch (error) {
            console.error("Error loading file:", error);
            setSelectedDocument(null);
            setSelectedDocumentName(null);
        } finally {
            setIsDocumentLoading(false);
        }
    };

    return (
        <React.Fragment>
            <div className="tw-bg-white tw-border-t tw-relative tw-bottom-0 tw-w-full">
                {mediaFileName !== null && (
                    <div
                        className=" position-absolute z-3 tw-p-1 rounded-2 d-flex"
                        style={{ bottom: "80px", left: "28px", backgroundColor: "#dce0dd" }}
                    >
                        <div className="tw-relative tw-w-[80px] tw-h-[80px] ">
                            {file && (
                                <img
                                    src={URL.createObjectURL(file)}
                                    alt=""
                                    className={`tw-w-[80px] tw-h-[80px] tw-rounded ${isImageUploading ? "tw-opacity-50" : ""}`}
                                />
                            )}

                            {/* Loading overlay */}
                            {isImageUploading && (
                                <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-30 tw-rounded">
                                    <div className="tw-animate-spin tw-h-6 tw-w-6 tw-border-2 tw-border-white tw-border-t-transparent tw-rounded-full"></div>
                                </div>
                            )}

                            {/* Close button */}
                            <CiSquareRemove
                                onClick={handleRemoveMediaFile}
                                size={24}
                                cursor={"pointer"}
                                className={`tw-absolute tw-right-1 tw-top-1 tw-text-white tw-bg-black tw-bg-opacity-50 tw-rounded-full ${isImageUploading ? "tw-opacity-50 tw-pointer-events-none" : ""}`}
                            />
                        </div>
                    </div>
                )}
                {(selectedDocument !== null || isDocumentLoading) && (
                    <div
                        className=" position-absolute z-3 tw-p-3 rounded-2 d-flex"
                        style={{ bottom: "80px", left: "28px", backgroundColor: "#dce0dd", minWidth: "200px" }}
                    >
                        <div className="tw-relative tw-flex tw-items-center tw-gap-3 tw-w-full">
                            <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-primary tw-text-white tw-rounded-md tw-p-2 tw-min-w-[50px] tw-h-[50px]">
                                {isDocumentLoading ? (
                                    <div className="tw-animate-spin tw-h-5 tw-w-5 tw-border-2 tw-border-white tw-border-t-transparent tw-rounded-full"></div>
                                ) : (
                                    <IoDocumentTextOutline size={24} />
                                )}
                            </div>
                            <div className="tw-flex tw-flex-col tw-flex-1">
                                <p className="tw-text-sm tw-font-semibold tw-text-gray-800 tw-mb-1">
                                    {isDocumentLoading ? "Loading Document..." : "Document Selected"}
                                </p>
                                <p className="tw-text-xs tw-text-gray-600 tw-truncate">
                                    {isDocumentLoading ? "Please wait..." : selectedDocumentName || "Ready to send"}
                                </p>
                            </div>
                            <CiSquareRemove
                                onClick={handleRemoveMediaFile}
                                size={20}
                                cursor={"pointer"}
                                className="tw-text-gray-600 hover:tw-text-red-500"
                            />
                        </div>
                    </div>
                )}
                <div className="chat-input-section  p-2   mb-0 tw-relative  tw-bg-white">
                    <Form onSubmit={(e) => onaddMessage(e, textMessage)}>
                        <Row className="g-0 ">
                            <Col className=" tw-bg-white tw-border-1 tw-rounded-md tw-mb-2">
                                <div style={{ border: "" }} className=" rounded-4 tw-relative">
                                    {moreIconClicked && (
                                        <div
                                            ref={attachmentIconRef}
                                            className=" tw-absolute -tw-top-14 tw-left-5 tw-shadow-lg  tw-bg-white tw-gap-2 tw-z-50 tw-rounded-md tw-w-[170px] tw-p-3"
                                        >
                                            <div className="tw-flex tw-flex-row tw-justify-center tw-gap-3">
                                                <button
                                                    onClick={() => {
                                                        setisOpen(true);
                                                        setMoreIconClicked(false);
                                                    }}
                                                    className="tw-flex tw-flex-col tw-items-center tw-bg-[#EAEEF4] tw-rounded-lg tw-p-2 tw-px-4 tw-w-[60px] tw-h-[54px] tw-justify-center"
                                                >
                                                    <IoDocumentTextOutline className="tw-text-primary" size={25} />
                                                    <p className="tw-text-[9px] tw-text-[#181818]">Documents</p>
                                                </button>

                                                <button
                                                    onClick={() => {
                                                        inputRef.current.click();
                                                    }}
                                                    className="tw-flex tw-flex-col tw-items-center tw-bg-[#EAEEF4] tw-rounded-lg tw-p-2 tw-px-4 tw-w-[60px] tw-h-[54px] tw-justify-center"
                                                >
                                                    <RiAttachment2 className="tw-text-primary" size={25} />
                                                    <p className="tw-text-[9px] tw-text-[#181818]">Media</p>
                                                    <input
                                                        ref={inputRef}
                                                        onChange={(e) => handleChange(e)}
                                                        type="file"
                                                        accept="image/png, image/jpeg, image/jpg"
                                                        name="fileInput"
                                                        size="60"
                                                        hidden
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    <InputGroup className="tw-flex gap-2 tw-items-center tw-bg-white tw-rounded-lg">
                                        <BsThreeDotsVertical
                                            onClick={() => setMoreIconClicked(!moreIconClicked)}
                                            className="tw-text-[24px] tw-ml-2 tw-text-primary"
                                        />
                                        <Input
                                            type="text"
                                            value={textMessage}
                                            onChange={handleChange}
                                            placeholder="Type your message..."
                                            className="tw-h-[40px] tw-outline-none tw-border-none tw-bg-white 
             focus:tw-shadow-none focus:tw-ring-0 focus:tw-border-none
             tw-rounded-md placeholder:text-gray-600 text-base"
                                        />

                                        <BsEmojiSmile
                                            onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                                            className="tw-text-[22px] tw-mr-2 tw-text-primary tw-cursor-pointer hover:tw-text-primary-dark tw-transition-colors"
                                        />

                                        <button
                                            type="submit"
                                            className="waves-effect tw-mr-2 waves-light bg-white rounded-4 tw-bg-white tw-flex tw-justify-end"
                                        >
                                            <IoMdSend className="tw-h-[24px] tw-w-[24px] tw-object-contain tw-text-primary" alt="send" />
                                        </button>
                                    </InputGroup>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </div>

                {/* Emoji Picker */}
                {showEmojiPicker && (
                    <div ref={emojiPickerRef} className="tw-absolute tw-bottom-16 tw-right-4 tw-z-50">
                        <EmojiPicker
                            onEmojiClick={onEmojiClick}
                            width={300}
                            height={350}
                            searchDisabled={false}
                            skinTonesDisabled={false}
                            previewConfig={{
                                showPreview: false,
                            }}
                        />
                    </div>
                )}

                {isOpen && (
                    <div
                        style={{
                            backgroundColor: "rgba(0,0,0,0.6)",
                            backdropFilter: "blur(4px)",
                        }}
                        className="tw-fixed tw-top-0 tw-left-0 tw-z-[999] tw-flex tw-items-center tw-justify-center tw-w-full tw-h-screen tw-p-4"
                    >
                        <div className="tw-w-full tw-max-w-2xl tw-bg-white tw-rounded-xl tw-shadow-2xl tw-overflow-hidden tw-max-h-[85vh] tw-flex tw-flex-col">
                            {/* Header */}
                            <div className="tw-bg-primary tw-px-6 tw-py-4">
                                <div className="tw-flex tw-justify-between tw-items-center">
                                    <div className="tw-flex tw-items-center tw-gap-3">
                                        <div className="tw-bg-white tw-bg-opacity-20 tw-p-2 tw-rounded-lg">
                                            <IoDocumentTextOutline className="tw-text-white" size={24} />
                                        </div>
                                        <div>
                                            <h1 className="tw-font-bold tw-text-xl tw-text-white">Select Document</h1>
                                            <p className="tw-text-white tw-text-opacity-80 tw-text-sm">Choose a document to attach to your message</p>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => setisOpen(false)}
                                        className="tw-p-2 tw-rounded-lg tw-bg-white tw-bg-opacity-20 hover:tw-bg-opacity-30 tw-transition-all tw-duration-200"
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path d="M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M6 18L18 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            {/* Content */}
                            <div className="tw-flex-1 tw-overflow-auto tw-p-6">
                                {user_docs?.length === 0 ? (
                                    <div className="tw-text-center tw-py-12">
                                        <div className="tw-bg-gray-100 tw-w-16 tw-h-16 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4">
                                            <IoDocumentTextOutline className="tw-text-gray-400" size={32} />
                                        </div>
                                        <h3 className="tw-text-lg tw-font-medium tw-text-gray-900 tw-mb-2">No documents found</h3>
                                        <p className="tw-text-gray-500">You don't have any documents uploaded yet.</p>
                                    </div>
                                ) : (
                                    <div className="tw-space-y-3">
                                        {user_docs?.map((item, index) => (
                                            <div
                                                key={index}
                                                className="tw-group tw-flex tw-items-center tw-justify-between tw-p-4 tw-border tw-border-gray-200 tw-rounded-lg hover:tw-border-primary hover:tw-shadow-md tw-transition-all tw-duration-200 tw-bg-white"
                                            >
                                                <div className="tw-flex tw-items-center tw-gap-4 tw-flex-1 tw-min-w-0">
                                                    <div className="tw-bg-background_color tw-p-3 tw-rounded-lg group-hover:tw-bg-primary group-hover:tw-bg-opacity-10 tw-transition-colors tw-duration-200">
                                                        <IoDocumentTextOutline className="tw-text-primary" size={20} />
                                                    </div>
                                                    <div className="tw-flex-1 tw-min-w-0">
                                                        <h3 className="tw-font-medium tw-text-gray-900 tw-truncate">{item.name}</h3>
                                                        <p className="tw-text-sm tw-text-gray-500 tw-mt-1">PDF Document</p>
                                                    </div>
                                                </div>
                                                <button
                                                    onClick={() => handleSelect(item)}
                                                    className="tw-px-4 tw-py-2 tw-bg-primary tw-text-white tw-rounded-lg hover:tw-bg-primary hover:tw-bg-opacity-90 tw-transition-colors tw-duration-200 tw-font-medium tw-text-sm tw-shadow-sm hover:tw-shadow-md"
                                                >
                                                    Select
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Footer */}
                            <div className="tw-bg-background_color tw-px-6 tw-py-4 tw-border-t tw-border-background_secondary_color">
                                <div className="tw-flex tw-justify-between tw-items-center tw-text-sm tw-text-medium_text">
                                    <span>
                                        {user_docs?.length || 0} document{user_docs?.length !== 1 ? "s" : ""} available
                                    </span>
                                    <button
                                        onClick={() => setisOpen(false)}
                                        className="tw-text-medium_text hover:tw-text-primary tw-transition-colors tw-duration-200"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

export default ChatInput;
